import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";

/**
 * Allows platform admins and organizers into the organizer console.
 * Regular customers are redirected home.
 */
export default function OrganizerRoute() {
  const loc = useLocation();
  let user = null;
  try {
    user = JSON.parse(localStorage.getItem("bb_user") || "null");
  } catch {
    user = null;
  }

  if (!user?.token) {
    return <Navigate to="/login" replace state={{ from: loc.pathname }} />;
  }

  const role = String(user.role || "").toLowerCase();
  if (role !== "admin" && role !== "organizer") {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
